import React from 'react';
import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';
import SERPListItemShape from '../../common/types/SERPListItemShape';

/**
 * Format schema.org data for itemlist
 * @param {itemlist} all items must include a url
 * @returns JSON schema.org object
 */
export const getItemListSchemaOrgJsonLD = ({ itemList }) => ({
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  itemListElement: itemList,
});

/**
 * Return both standard meta data and schema.org JSON-LD for a
 * Category page (think programs/course list pages)
 * @param {meta} meta object that represents description, image, url, and title.
 * @param {itemList} list of the items being displayed on the page
 * @returns Helmet code that renders out the metadata, itemlist, and website information
 */
export function SEOItemList({ itemList }) {
  const itemListJsonLD = getItemListSchemaOrgJsonLD({ itemList });
  return (
    <Helmet>
      <script id="serpItemList" type="application/ld+json">{JSON.stringify(itemListJsonLD)}</script>
    </Helmet>
  );
}

SEOItemList.propTypes = {
  itemList: PropTypes.arrayOf(SERPListItemShape).isRequired,
};
